module.exports = "<div id=\"bar_chart\"\r\n  *ngIf=\"barData\"\r\n  [chartData]=\"barData\"\r\n  [chartOptions] = \"barOptions\"\r\n  [selectionCallback] = \"selectionCallback\"\r\n  chartType=\"ColumnChart\"\r\n  GoogleChart\r\n  class=\"content-box\"></div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Alec/Documents/dev/recog/recog/src/app/collection-module/view/bar-graph/bar-graph.component.html
// module id = ../../../../../src/app/collection-module/view/bar-graph/bar-graph.component.html
// module chunks = main